module.exports = __webpack_public_path__ + "86590ea10b695941fbc3d81416b94b44.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/Seller_order-id_example.png
// module id = 161
// module chunks = 0